function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredba1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredba1"] = parcelRequire;
}
parcelRequire.register("7aR5V", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $5392a70fa331eaa8$export$6503ec6e8aabbaf; }, function (v) { return $5392a70fa331eaa8$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $5392a70fa331eaa8$export$f7ad0328861e2f03; }, function (v) { return $5392a70fa331eaa8$export$f7ad0328861e2f03 = v; });
var $5392a70fa331eaa8$export$6503ec6e8aabbaf;
var $5392a70fa331eaa8$export$f7ad0328861e2f03;
"use strict";
var $5392a70fa331eaa8$var$mapping = {};
function $5392a70fa331eaa8$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$5392a70fa331eaa8$var$mapping[keys[i]] = pairs[keys[i]];
}
function $5392a70fa331eaa8$var$resolve(id) {
    var resolved = $5392a70fa331eaa8$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$5392a70fa331eaa8$export$6503ec6e8aabbaf = $5392a70fa331eaa8$var$register;
$5392a70fa331eaa8$export$f7ad0328861e2f03 = $5392a70fa331eaa8$var$resolve;

});

var $86bdb8292e0d42e1$exports = {};

(parcelRequire("7aR5V")).register(JSON.parse('{"bTh70":"index.0afa280e.js","2RJD2":"ae_logo_flat.738148a8.svg","8KlO0":"onfido_logo.c2975af7.svg","bJTCM":"idin_logo.2a32eee0.svg","hZCLS":"search_icon.209df2db.svg","3gQjh":"complete-check.11e9d857.svg","6lvuX":"index.175bc4bb.css"}'));


//# sourceMappingURL=index.5ca12838.js.map
